// extracted by mini-css-extract-plugin
module.exports = {"active-button-default-no-margins":"style_active-button-default-no-margins__1CPQx","button-default-no-margins":"style_button-default-no-margins__1TBD_"};